module.exports = __webpack_public_path__ + "static/media/menuBackgroundBlue.01e15be4.svg";